import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';
import Page from 'src/components/Page';
import Table from 'src/components/Table';

function TestTxnPage() {

    return <Page header="Test mode transactions">
        <p>
            Whilst integrating or otherwise testing, transactions can be performed in test mode for all payment types.
            Test transactions are visible and searchable in the Backoffice, but are not sent to an actual external payment processor API.
            They can be differentiated by inspecting the <code>isTestTxn</code> flag in the <code>Txn</code> object returned by the API.
        </p>

        <p>
            Specific responses can be obtained for test mode transactions to test the various scenarios likely to be encountered while processing payments.
        </p>
        <h2>Test cards</h2>
        <Table
            headers={['Card Type', 'Card Number']}
            body={[
                ['Mastercard', '5123456789012346'],
                ['Mastercard 2 Series', '2720010040360012'],
                ['Visa', '4987654321098769'],
                ['American Express', '345678901234564'],
                ['Diners', '30123456789019'],
                ['JCB', '3530111333300000'],
            ]}
        />
        <h2>Simulating bank response codes</h2>

        <p>
            While performing test mode transactions, specific parameters can be provided to obtain specific simulated <Link to={routes.reference.bankResponseCodes}>bank response codes</Link>.
        </p>

        <p>
            Response codes between 00 and 99 can be obtained using any of the two methods:
        </p>
        <h3>Last two digits in transaction amount method</h3>
        <p>
            To simulate a bank response code, use the last two digits in the transaction amount.  Please note the transaction amount is stated in cents.  For example, <code>10005</code> (represents $100.05)
            will generate a bank response code of <code>05</code>.  Another example is a transaction amount of <code>211</code> generating a bank response code of <code>11</code>.
        </p>
        <h3>Expiry method</h3>
        <p>            
            To simulate a bank response code using the Expiry method, set the month component to <code>99</code> and set the year component (where the year is a two digit representation; for example, the year 2023 would be represented as 23)
            to the bank response code you desire.  For example, submitting a transaction with an expiry date of <code>9945</code> will result in a bank response code of <code>45</code>.
        </p>

        <h2>Simulating CVN Responses</h2>
        <p>
            The following CVN values can be submitted to obtain the listed simulated <Link to={routes.reference.bankResponseCodes + '#cvnResponseCodes'}>CVN response codes</Link>:
        </p>

        <Table
            headers={['CVN', 'CVN Response', 'Bank Response Code']}
            body={[
                ['987', 'N', '05, regardless of amount or expiry date'],
                ['876', 'P', 'Determined by amount or expiry date'],
                ['765', 'U', 'Determined by amount or expiry date'],
                ['All others', 'M', 'Determined by amount or expiry date'],
            ]}
        />

        <h2>Simulating timeouts</h2>
        <p>
            To simulate a timeout, set the transaction amount to <code>11199</code> ($111.99). This will result in a 50 second delay before a PT_G5 response code is returned.
        </p>

    </Page>;
}

export default TestTxnPage;